import { createServerFn } from "@tanstack/react-start";
import { setResponseHeader } from "@tanstack/react-start/server";
import { createClient } from "@supabase/supabase-js";
import type { Database } from "@/integrations/supabase/types";
import { isPastEvent } from "@/lib/events-calendar";
import { mapPublicEventRow, type PublicEventFeedRow } from "@/lib/public-events";

/**
 * Предстоящие события города для публичной страницы /afisha/<slug>.
 * Тот же источник, что у гостевой афиши: RPC public_events_feed (anon),
 * без location_details в выдаче карточек и без контактов.
 */
export const getAfishaCityEvents = createServerFn({ method: "GET" })
  .inputValidator((city: string) => city)
  .handler(async ({ data: city }) => {
    setResponseHeader("Cache-Control", "public, s-maxage=900, stale-while-revalidate=3600");
    const url = process.env.SUPABASE_URL ?? import.meta.env.VITE_SUPABASE_URL;
    const key = process.env.SUPABASE_PUBLISHABLE_KEY ?? import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;
    const sb = createClient<Database>(url, key, {
      auth: { persistSession: false, autoRefreshToken: false },
    });
    const { data, error } = await sb.rpc("public_events_feed");
    if (error) throw new Error("Afisha unavailable");
    const now = new Date();
    return ((data ?? []) as PublicEventFeedRow[])
      .filter((e) => e.city === city && !!e.event_date && !isPastEvent(e, now))
      .sort((a, b) => new Date(a.event_date!).getTime() - new Date(b.event_date!).getTime())
      .map(mapPublicEventRow);
  });
